import { graphql, HttpResponse } from 'msw'
import { type EnrollmentMultiGetStartedData, type EnrollmentMultiGetStartedSubmitOutput } from '../../../../models'

export const getEnrollmentMultiGetStartedDataMock: EnrollmentMultiGetStartedData = {
  __typename: 'SubmitEnrollmentSuccess',
  path: '/enrollment/multi/get-started',
}

export const submitEnrollmentMultiGetStartedDataMock: EnrollmentMultiGetStartedSubmitOutput = {
  __typename: 'SubmitEnrollmentSuccess',
  path: '/enrollment/multi/verify-email',
}

export const mockGetEnrollmentMultiGetStartedData = graphql.mutation('getEnrollmentMultiGetStartedData', () => {
  return HttpResponse.json({ data: { submitEnrollment: getEnrollmentMultiGetStartedDataMock } })
})

export const mockSubmitEnrollmentMultiGetStartedData = graphql.mutation(
  'submitEnrollmentMultiGetStartedData',
  ({ cookies }) => {
    if (cookies.submitEnrollmentMultiGetStartedData) {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
      return HttpResponse.json(JSON.parse(cookies.submitEnrollmentMultiGetStartedData))
    }
    return HttpResponse.json({ data: { submitEnrollment: submitEnrollmentMultiGetStartedDataMock } })
  },
)

export const mockEnrollmentMultiGetStarted = [
  mockGetEnrollmentMultiGetStartedData,
  mockSubmitEnrollmentMultiGetStartedData,
]
